import { LatLngAlt } from "../../../types.js";

const stream: LatLngAlt[] = [
  [51.495506, -0.111104, 3.4],
  [51.495371, -0.111137, 3.2],
  [51.495237, -0.111162, 3],
  [51.495109, -0.111187, 3.2],
  [51.49498, -0.111212, 3.6],
  [51.494856, -0.111241, 4],
  [51.494738, -0.111269, 4.4],
  [51.494631, -0.111295, 4.8],
  [51.494524, -0.111333, 5.2],
];

export default stream;
